import Dempsey from '../../media/banner/dempsey-hill.png'
import Fasaddempsey from '../../media/banner/fasad dempsey hill.png'
import pelican from '../../media/banner/pelican hill.png'
import madison from '../../media/banner/fasad madison.png'
import northwestpark from '../../media/banner/northwest park.png'
import atalanta from '../../media/banner/fasad atalanta.png'
import northwestcentral from '../../media/banner/northwest central.png'
import freja from '../../media/banner/fasad freja.png'
import hera from '../../media/banner/fasad hera.png'
import northwestlake from '../../media/banner/northwest lake.png'
import northwesthill from '../../media/banner/northwest hill.png'

const images =[
    Dempsey,Fasaddempsey,pelican,madison,northwestpark,atalanta,northwestcentral,freja,hera,northwestlake,northwesthill
]

export default images;
